var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFA726",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3126 30.2973L39.6751 35.2173L41.3638 42.5422C41.4532 42.9252 41.4277 43.326 41.2905 43.6945C41.1533 44.063 40.9106 44.3829 40.5926 44.6142C40.2746 44.8455 39.8954 44.9779 39.5026 44.9949C39.1097 45.0119 38.7206 44.9127 38.3838 44.7097L31.9951 40.8347L25.6201 44.7097C25.2833 44.9127 24.8941 45.0119 24.5013 44.9949C24.1084 44.9779 23.7293 44.8455 23.4113 44.6142C23.0933 44.3829 22.8505 44.063 22.7134 43.6945C22.5762 43.326 22.5507 42.9252 22.6401 42.5422L24.3263 35.2248L18.6876 30.2973C18.3893 30.04 18.1737 29.7005 18.0676 29.3212C17.9616 28.9419 17.9699 28.5397 18.0915 28.1651C18.2131 27.7905 18.4426 27.4602 18.7512 27.2155C19.0599 26.9708 19.4338 26.8227 19.8263 26.7898L27.2588 26.146L30.1601 19.226C30.3116 18.8629 30.5671 18.5527 30.8945 18.3346C31.222 18.1164 31.6066 18 32.0001 18C32.3935 18 32.7781 18.1164 33.1056 18.3346C33.433 18.5527 33.6885 18.8629 33.8401 19.226L36.7501 26.146L44.1801 26.7898C44.5725 26.8227 44.9465 26.9708 45.2551 27.2155C45.5637 27.4602 45.7932 27.7905 45.9148 28.1651C46.0365 28.5397 46.0448 28.9419 45.9387 29.3212C45.8327 29.7005 45.617 30.04 45.3188 30.2973H45.3126Z",
    fill: "#FFA726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.3bb64bdc57fa31f0bcea4d42ef3ef392.svg";
export { ForwardRef as ReactComponent };